import { FC } from 'react';
import { Content, PageSectionHeader } from '@/components';

/** Placeholder: routed and reachable, but not built yet. */
const Dashboard: FC = () => (
  <>
    <PageSectionHeader>Dashboard</PageSectionHeader>
    <Content>
      <p>This page has not been built yet.</p>
    </Content>
  </>
);

export default Dashboard;
